// @ts-nocheck
// W13d: refactor para Mantine (sem AntD Col), function component + hooks.
// Renderiza a legenda inferior do mapa — "Lotes" e demais overlays ativos com suas cores.
import { useSelector } from "react-redux";
import { Group, Paper, Text } from "@mantine/core";
import StyleFactory from "./geocloud2/StyleFactory.js";
import "./SmartMapLegend.css";

// W13f: ref estavel para evitar "Selector returned a different result" warning
// quando state.audit eh undefined (objeto {} novo a cada chamada).
const EMPTY_FILTERS = {};

export interface SmartMapLegendProps {
  className?: string;
  showGeocloudStyles?: boolean;
}

interface LegendItem {
  text: string;
  fill: string;
  stroke?: string;
}

function uniqByKey(items: LegendItem[]): LegendItem[] {
  const seen = new Set<string>();
  const out: LegendItem[] = [];
  items.forEach((item) => {
    const key = `${item.text}__${item.fill}__${item.stroke ?? ""}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push(item);
    }
  });
  return out;
}

function parseLegend(config: any): LegendItem[] {
  if (!config || !config.legend || !config.showLayer) return [];
  let legend: LegendItem[] = [];
  if (typeof config.legend === "string") {
    legend = JSON.parse(config.legend);
  } else {
    config.legend.forEach((x: string) => {
      legend.push(...JSON.parse(x));
    });
  }
  return uniqByKey(legend);
}

function LegendChip({ fill, stroke, label }: { fill: string; stroke?: string; label: string }) {
  return (
    <Group gap={6} wrap="nowrap" className="legend-text">
      <span
        className="legend"
        style={{ backgroundColor: fill, borderColor: stroke ?? fill }}
      />
      <Text size="xs">{label}</Text>
    </Group>
  );
}

export default function SmartMapLegend({
  className = "",
  showGeocloudStyles = false,
}: SmartMapLegendProps) {
  const config = useSelector((s: any) => s.smartMap?.config);
  const filters = useSelector((s: any) => s.audit?.filters ?? EMPTY_FILTERS);

  const legend = parseLegend(config);

  let geocloudStyles: any[] = [];
  if (showGeocloudStyles && filters?.selectedTheme?.styles) {
    geocloudStyles = [...filters.selectedTheme.styles];
    if (filters.selectedTheme.fieldDefinitionAlias === "Sem Tema") {
      geocloudStyles.shift();
      if (geocloudStyles[0]) geocloudStyles[0].key = "Sem Tema";
    } else {
      geocloudStyles.splice(0, 2);
    }
  }

  // Nada para mostrar: não renderiza o paper
  if (legend.length === 0 && geocloudStyles.length === 0) return null;

  return (
    <Paper withBorder px="sm" py="xs" mt="xs" radius="sm" className={className}>
      <Group gap="md" wrap="wrap">
        {legend.map((item, i) => (
          <LegendChip
            key={`${item.text}_${i}`}
            fill={item.fill}
            stroke={item.stroke}
            label={item.text}
          />
        ))}
        {showGeocloudStyles &&
          geocloudStyles.map((item) => {
            const itemStyle = StyleFactory.loadStyle(item.value);
            return (
              <LegendChip
                key={item.key}
                fill={itemStyle.fillStyle}
                stroke={itemStyle.strokeStyle ?? itemStyle.fillStyle}
                label={item.key}
              />
            );
          })}
      </Group>
    </Paper>
  );
}
